import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import messages from '../messages';
import * as constants from '../constants';
import { commandWorkspacePluginDetails } from '../actions';

export function* sendRequest(connection, action) {
  const workspacePluginUpdate = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PLUGIN_UPDATE,
    pluginId: action.pluginId,
    publishMode: action.publishMode,
  });

  if (workspacePluginUpdate.type === constants.RTM_WORKSPACE_PLUGIN_UPDATE_OK) {
    yield put(commandWorkspacePluginDetails(action.pluginId));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspacePluginUpdate} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PLUGIN_UPDATE, catchErrors, sendRequest, connection);
}
